<div class="brd-shell">
  <brd-navbar></brd-navbar>
  <main class="brd-body">
    <div class="brd-body-content" *ngIf="!loading; else loadingTemplate">
      <router-outlet></router-outlet>
    </div>
    <ng-template #loadingTemplate>
      <div class="brd-body-content loading">BOARD DEMO PORTAL</div>
    </ng-template>
    <brd-navbar-footer></brd-navbar-footer>
  </main>
</div>
